import { Box, Button, Grid, Typography } from "@mui/material";
import { useNavigateWithParams } from "@northpowerdev/np-react-utils";
import { useContext, useState } from "react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { DebugBox } from "@northpowerdev/np-react-utils";
import { MahiContext } from "../../state/MahiContext";

export default function QRTagView() {

    const [tagId, setTagId] = useState(null)

    const location = useLocation()
    const navigateWithParams = useNavigateWithParams('/tag/details')

    const mahiContext = useContext(MahiContext)
    const userRoles = mahiContext.userRoles
    const isAuthForTagDetails = (userRoles?.length && userRoles.includes('Mahi.IsolationTags'))

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search)
        const paramTagId = searchParams.get('tag_id')
        setTagId(paramTagId)
    }, [location])

    const handleNavigateToDetails = () => {
        console.log('handleNavigateToDetails')
        navigateWithParams({tag_id: tagId})
    }

    return (
        <Box className="Page">
            <h2 className="np-title">View Tag</h2>
            <Grid container sx={{my:4}}>
                <Grid item xs={12} md={6} sx={{mb:2}} textAlign="center">
                    <img alt="qr tag" src="/qr-tag.jpg" />
                </Grid>
                <Grid item xs={12} md={6}>
                    <Typography variant="h6" paragraph>Northpower Safety Isolation Tags</Typography>
                    <Typography variant="body1" paragraph>
                        We use safety isolation tags at places where the network is disconnected or reconnected.
                        Safety isolation tags are used by Northpower staff and approved contractors only.
                        Do not tamper with the tag or use its presence or absence to make assumptions about the status of a power line.
                    </Typography>
                    <Typography variant="body1" paragraph>
                        <strong>Please treat lines as live at all times and stay well back.</strong>
                    </Typography>
                    <Typography variant="body1" paragraph>
                        For more information call Northpower Faults on 0800 10 40 40.
                    </Typography>
                    {
                        (tagId && isAuthForTagDetails)
                        ?
                            <Box>
                                <Button variant="contained" onClick={handleNavigateToDetails}>Tag Details</Button>
                            </Box>
                        :
                            null
                    }
                    <DebugBox title="tagId" sx={{mt:4}}>{tagId}</DebugBox>
                    <DebugBox title="isAuthForTagDetails">{isAuthForTagDetails ? 'true' : 'false'}</DebugBox>
                    <DebugBox title="userRoles" stringify>{userRoles}</DebugBox>
                </Grid>
            </Grid>
        </Box>
    )
}




